import './ProgressBar.css';

interface ProgressBarProps {
  value: number;
  max?: number;
  label?: string;
  showPercentage?: boolean;
  color?: 'cyan' | 'magenta';
}

export function ProgressBar({
  value,
  max = 100,
  label,
  showPercentage = true,
  color = 'cyan',
}: ProgressBarProps) {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));

  return (
    <div className="progress-bar">
      {(label || showPercentage) && (
        <div className="progress-label">
          <span>{label}</span>
          {showPercentage && (
            <span className="progress-text">{Math.round(percentage)}%</span>
          )}
        </div>
      )}
      <div className="progress-track">
        <div
          className={`progress-fill progress-${color}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}

